import { render } from "./OptionalLabel.vue?vue&type=template&id=81df1a62"
import script from "./OptionalLabel.vue?vue&type=script&lang=js"
export * from "./OptionalLabel.vue?vue&type=script&lang=js"

import exportComponent from "/home/alexey/mv/mortgageware/vendor/sudoux/cms/Sudoux/Cms/FormBundle/Resources/views/Vuejs/Apps/formbuilder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__